var _circle, _ellipse, _circle2, _ellipse2, _circle3, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 21,
    cy: 5.5,
    r: 3,
    fill: "url(#paint0_linear_2760_48934)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 21,
    cy: 13.75,
    rx: 5.25,
    ry: 3,
    fill: "url(#paint1_linear_2760_48934)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 9,
    cy: 5.5,
    r: 3,
    fill: "url(#paint2_linear_2760_48934)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 9,
    cy: 13.75,
    rx: 5.25,
    ry: 3,
    fill: "url(#paint3_linear_2760_48934)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9974,
    cy: 4.99935,
    r: 3.33333,
    fill: "#FB512D",
    stroke: "#FB512D",
    strokeWidth: 1.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9974,
    cy: 14.1673,
    rx: 5.83333,
    ry: 3.33333,
    fill: "#FB512D",
    stroke: "#FB512D",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2760_48934",
    x1: 21.0028,
    y1: 8.5,
    x2: 21.0028,
    y2: 2.50377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE9E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2760_48934",
    x1: 21.0049,
    y1: 16.75,
    x2: 21.0049,
    y2: 10.7538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE9E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2760_48934",
    x1: 9.00277,
    y1: 8.5,
    x2: 9.00277,
    y2: 2.50377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE9E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2760_48934",
    x1: 9.00485,
    y1: 16.75,
    x2: 9.00485,
    y2: 10.7538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE9E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUser);
export default __webpack_public_path__ + "static/media/groupUser.b644b1b47d9e126d66eea6cb80294e70.svg";
export { ForwardRef as ReactComponent };